import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, ExternalLink } from 'lucide-react';

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-[#050404] border-t border-[#C5A059]/10">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 pt-12 lg:pt-16 pb-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Logo & Slogan */}
          <div className="lg:col-span-1">
            <Link to="/" data-testid="footer-logo">
              <img 
                src="https://customer-assets.emergentagent.com/job_menuiserie-doree/artifacts/r267ou8u_1.png" 
                alt="Rozier Menuiserie" 
                className="h-16 w-auto mb-6"
              />
            </Link>
            <p className="text-[#a39c93] text-sm leading-relaxed font-body">
              L'invisible structure le visible
            </p>
            <div className="mt-6 h-px w-16 bg-[#C5A059]/30"></div>
          </div>

          {/* Expertises */}
          <div>
            <h4 className="font-heading text-xl text-[#fdfbf7] mb-6">Expertises</h4>
            <nav className="flex flex-col gap-3">
              <Link 
                to="/menuiserie" 
                data-testid="footer-link-menuiserie"
                className="text-[#a39c93] hover:text-[#C5A059] transition-colors text-sm font-body"
              >
                Menuiserie
              </Link>
              <Link 
                to="/ossature-bois" 
                data-testid="footer-link-ossature"
                className="text-[#a39c93] hover:text-[#C5A059] transition-colors text-sm font-body"
              >
                Ossature Bois
              </Link>
              <Link 
                to="/isolation" 
                data-testid="footer-link-isolation"
                className="text-[#a39c93] hover:text-[#C5A059] transition-colors text-sm font-body"
              >
                Isolation
              </Link>
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-xl text-[#fdfbf7] mb-6">Contact</h4>
            <div className="flex flex-col gap-4">
              <a 
                href="tel:+33609136334" 
                data-testid="footer-phone"
                className="flex items-center gap-3 text-[#a39c93] hover:text-[#C5A059] transition-colors text-sm font-body"
              >
                <Phone size={16} className="text-[#C5A059]" />
                06 09 13 63 34
              </a>
              <a 
                href="mailto:contact@rozier-menuiserie.fr" 
                data-testid="footer-email"
                className="flex items-center gap-3 text-[#a39c93] hover:text-[#C5A059] transition-colors text-sm font-body"
              >
                <Mail size={16} className="text-[#C5A059]" />
                contact@rozier-menuiserie.fr
              </a>
              <div className="flex items-start gap-3 text-[#a39c93] text-sm font-body">
                <MapPin size={16} className="text-[#C5A059] mt-0.5 flex-shrink-0" />
                <span>France entière</span>
              </div>
            </div>
          </div>

          {/* Rozier Concept */}
          <div>
            <h4 className="font-heading text-xl text-[#fdfbf7] mb-6">Rozier Concept</h4>
            <p className="text-[#a39c93] text-sm leading-relaxed font-body mb-4">
              Découvrez notre approche globale : Feng Shui, géobiologie, paysagisme et conception bioclimatique.
            </p>
            <a
              href="https://rozier-concept.fr"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-rozier-concept-link"
              className="inline-flex items-center gap-2 text-[#C5A059] hover:text-[#d6b46e] transition-colors text-sm font-body"
            >
              Visiter le site
              <ExternalLink size={14} />
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 pt-6 border-t border-[#C5A059]/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-center md:text-left">
            <p className="text-[#a39c93] text-xs font-body">
              © 2026 Rozier Menuiserie. Tous droits réservés.
            </p>
            <div className="flex items-center gap-4">
              <Link 
                to="/mentions-legales"
                className="text-[#a39c93] hover:text-[#C5A059] transition-colors text-xs font-body"
              >
                Mentions légales
              </Link>
              <span className="text-[#a39c93]/50">|</span>
              <Link 
                to="/politique-confidentialite"
                className="text-[#a39c93] hover:text-[#C5A059] transition-colors text-xs font-body"
              >
                Politique de confidentialité
              </Link>
            </div>
            <p className="text-[#a39c93] text-xs font-body">
              Site conçu et réalisé par{' '}
              <a 
                href="https://axeris-labs.fr" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#C5A059] hover:text-[#d6b46e] transition-colors"
              >
                Axeris Labs
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
